import PropTypes from "prop-types";
import React from "react";

// import { Panel, PanelGroup } from 'react-bootstrap';
import { Outlet, NavLink } from "react-router-dom";

import SettingsNotFoundSvgIcon from "../../images/404errorMessage.svg";
import PlaceholderEmptyMessage from "../../components/PlaceholderEmptyMessage";
import userRoleService from "../../../utils/userRoles.service";

import cx from "classnames";
import styles from "./Styles.module.scss";
import chatImage from "src/legacy/images/chat.svg"
// import { Item } from 'react-bootstrap/lib/Breadcrumb';
import _ from "lodash";
import { localizedStrings } from "../../../localization";
import LanguageService from "../../services/language.service";
import { Accordion } from "react-bootstrap";

class SettingsView extends React.Component {
  constructor(props) {
    super(props);

    // localized contents
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;

    this.state = {
      isIntercomActive: false, 
      settingsConfig: [
        {
          name: this.localizedSettings.tabs.profile,
          url: "/settings/profile",
          visible: () => {
            return true;
          },
        },
        {
          name: this.localizedSettings.tabs.notification,
          url: "/settings/notifications",
          visible: () => {
            return userRoleService.canAccessNotifications();
          },
        },
        {
          name: this.localizedSettings.tabs.account.title,
          url: "/settings/account-management",
          visible: () => {
            return true;
          },
          children: [
            {
              name: this.localizedSettings.tabs.account.account_management,
              url: "/settings/account-management",
              visible: () => {
                return userRoleService.canAccessAccountManagement();
              },
            },
            {
              name: this.localizedSettings.tabs.account.user_management,
              url: "/settings/user-management",
              visible: () => {
                return userRoleService.canAccessUserManagement();
              },
            },
            {
              name: this.localizedSettings.tabs.account.viewer_settings,
              url: "/settings/fliteview",
              visible: () => {
                return userRoleService.canAccessPromoteSettings();
              },
            },
            {
              name: this.localizedSettings.tabs.account.hub_settings,
              url: "/settings/hub-settings",
              visible: () => {
                return (
                  userRoleService.canCloneHub() &&
                  userRoleService.canEditLayout()
                );
              },
            },
            {
              name: this.localizedSettings.tabs.account.custom_fields,
              url: "/settings/custom_fields",
              visible: () => {
                return userRoleService.canAccessCustomFields();
              },
            },
            {
              name: this.localizedSettings.tabs.account.privacy_policy_control,
              url: "/settings/privacy-policy-control",
              visible: () => {
                return userRoleService.canAccessPrivacyPolicyControl();
              },
            },
            {
              name: this.localizedSettings.tabs.account.payment_history,
              url: "/settings/payment-history",
              visible: () => {
                return userRoleService.canAccessPaymentHistory(
                  _.get(this.props, "account"),
                );
              },
            },
          ],
        },
        {
          name: this.localizedSettings.tabs.stream_access_management,
          url: "/settings/stream-access-management",
          visible: () => {
            return (
              userRoleService.canAccessHub() &&
              userRoleService.canCreateStream()
            );
          },
        },
        {
          name: this.localizedSettings.tabs.experience_settings.title,
          url: "/settings/experience-settings/custom-form-fields",
          visible: () => {
            return userRoleService.isAdmin();
          },
          children: [
            {
              name: this.localizedSettings.tabs.experience_settings.custom_form_fields,
              url: "/settings/experience-settings/custom-form-fields",
              visible: () => {
                return userRoleService.isAdmin();
              },
            },
            {
              name: this.localizedSettings.tabs.experience_settings.form_management,
              url: "/settings/experience-settings/form-management",
              visible: () => {
                return userRoleService.isAdmin();
              },
            },
            {
              name: this.localizedSettings.tabs.experience_settings.brandkit,
              url: "/settings/experience-settings/brandkit",
              visible: () => {
                return userRoleService.isAdmin();
              },
            },
          ],
        },
        {
          name: this.localizedSettings.tabs.distribution_lists,
          url: "/settings/distribution_lists",
          visible: () => {
            return userRoleService.canAccessDistributionLists();
          },
        },
        {
          name: this.localizedSettings.tabs.content_sources,
          url: "/settings/data-sources",
          visible: () => {
            return userRoleService.canAccessDataSource();
          },
        },
        {
          name: this.localizedSettings.tabs.integrations,
          url: "/settings/integrations",
          visible: () => {
            return userRoleService.canAccessIntegrations();
          },
        },
        {
          name: this.localizedSettings.tabs.templates.title,
          url: "/settings/email-template",
          visible: () => {
            return userRoleService.canShare();
          },
          children: [
            {
              name: this.localizedSettings.tabs.templates.email,
              url: "/settings/email-template",
              visible: () => {
                return userRoleService.canAccessEmailTemplates();
              },
            },
            {
              name: this.localizedSettings.tabs.templates.nda,
              url: "/settings/nda-templates",
              visible: () => {
                return userRoleService.canAccessNdaTemplates();
              },
            },
          ],
        },
        {
          name: "Hey Sales",
          url: "/settings/skills",
          visible: () => {
            return userRoleService.canAccessCoaching() && userRoleService.canCreateCourse();
          },
          children: [
            {
              name: "Skills",
              url: "/settings/skills",
              visible: () => {
                return userRoleService.canAccessCoaching() && userRoleService.canCreateCourse();
              },
            },
          ]
        }
      ],
    };

    this.handleLink = this.handleLink.bind(this);
  }

  nameValue() {
    let { firstName, lastName } = this.props.user;
    var name = "";

    if (firstName) {
      name = name + " " + firstName;
    }

    if (lastName) {
      name = name + " " + lastName;
    }

    return name;
  }

  renderHeading(child) {
    const hasChildren = _.size(child.children) > 0;
    var children = (child.children || []).filter((menu) => {
      return menu.visible();
    });

    if (hasChildren && _.size(children) === 1 && child.name != "Hey Sales" ) {
      return (
        <div
          className={cx(styles.accordionHeader, {
            [styles.activePanel]: this.state.settingsUrl === children[0].url,
          })}
          onClick={() => this.handleLink(children[0])}
        >
          {children[0].name}{" "}
          <i className={cx("paperflite-dropdown", styles.dropDownIcon)} />
        </div>
      );
    }
    
    return (
      <div
        className={cx(styles.accordionHeader,styles.accordionHeaderSingle, {
          [styles.activePanel]: this.state.settingsUrl === child.url,
          [styles.multiLevelAccordionHeader] : hasChildren
        })}
        onClick={() => this.handleLink(child)}
      >
        {child.name}
        {hasChildren && <i className={cx("paperflite-dropdown", styles.dropDownIcon)} />}
      </div>
    );
  }

  handleIntercomClick = () => {
    this.setState(
      (prevState) => ({
        isIntercomActive: !prevState.isIntercomActive, 
      }),
      () => {
        if (this.state.isIntercomActive) {
          window.Intercom('show'); 
        } else {
          window.Intercom('hide'); 
        }
      }
    );
  };


  handleLink(child) {

    if(child.name === "Content Sources"){
      this.props.trackAdoptionMetricsForContentSourceClickedEvent();
    } else if(child.name === "Integrations"){
      this.props.trackAdoptionMetricsForIntegrationsClickedEvent();
    }

    const hasChildren = _.size(child.children) > 0;
    var children = (child.children || []).filter((menu) => {
      return menu.visible();
    });

    if (hasChildren && _.size(children) > 0) {
      this.setState({
        settingsUrl: children[0].url,
      });
      this.props.navigate(children[0].url);
    }

    if (!hasChildren) {
      this.setState({
        settingsUrl: child.url,
      });
      this.props.navigate(child.url);
    }

    if (
      hasChildren &&
      !child.url &&
      this.state.settingsUrl !== children[0].url
    ) {
      this.setState({
        settingsUrl: children[0].url,
      });
      this.props.navigate(children[0].url);
    }
  }

  canRenderPanel(child) {
    const hasChildren = _.size(child.children) > 0;
    var children = (child.children || []).filter((menu) => {
      return menu.visible();
    });

    if (hasChildren && _.size(children) == 0) {
      return false;
    }

    return true;
  }

  canRenderAccordion(child) {
    const hasChildren = _.size(child.children) > 0;
    var children = (child.children || []).filter((menu) => {
      return menu.visible();
    });

    if (!hasChildren) {
      return false;
    }

    return true;
  }

  componentDidMount() {
    this.props.trackAdoptionMetricsForSettingsScreenView();
    var path = this.props.location.pathname.split("/").slice(0, 3).join("/");
    this.setState({
      settingsUrl: path,
    });
  }

  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props.location.pathname, nextProps.location.pathname)){
    var path = nextProps.location.pathname.split("/").slice(0, 3).join("/");
    this.setState({
      settingsUrl: path,
      });
    }
  }

  _renderError() {
    return (
      <PlaceholderEmptyMessage
        title="Mmm... who moved my cheese?"
        message="Sorry!  Some one passed you the wrong information. You were never supposed to see me :)."
        image={SettingsNotFoundSvgIcon}
        className={styles.errorEmptyMessage}
        visible={true}
      />
    );
  }

  render() {
    var path = this.props.location.pathname.split("/").slice(0, 3).join("/");
    var permission = userRoleService.requirePermission(
      path,
      this.props.user,
      this.props.account,
    );

    return (
      <div className={styles.content}>
        <div
          className={cx(
            styles.rightview,
            styles.rightviewFull,
          )}
        >
          <Outlet />
          {permission ? this.props.children : this._renderError()}
        </div>
      </div>
    );
  }
}

class MenuItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var children = (this.props.item.children || []).filter((menu) => {
      return menu.visible();
    });

    if (_.size(children) > 0) {
      return (
        <li className={cx(styles.accordion, styles.accordionItem)}>
          <ul className={styles.accordionMenu}>
            {children.map((child) => {
              return <MenuItem item={child} />;
            })}
          </ul>
        </li>
      );
    }

    var item = this.props.item;

    return (
      <li className={styles.menuItem}>
        <NavLink
          className={({ isActive }) => {
            return cx(styles.menuLink, {
              [styles.active]: isActive,
            });
          }}
          to={item.url}
        >
          {item.name}
        </NavLink>
      </li>
    );
  }
}

SettingsView.contextTypes = {
  lite: PropTypes.bool,
}

export default SettingsView;
